import { combineReducers } from 'redux';
import authorizationReducer from './authorization.reducer';
import messageReducer from './message.reducer';
import rolesReducer from './roles.reducer';
import languageReducer from './language.reducer';
import dynamicReducer from './dynamic.reducer';
import feedReducer from './feed.reducer';
import subscriptionReducer from './subscription.reducer';
import userReducer from './userSlice';

// API Services - Legacy
import { userApi } from '../../services/user';

// DDD Domains - New structure
import { authApi } from '../../domains/auth/infrastructure/api/auth.api';
import { paymentApi } from '../../domains/payment/infrastructure/api/payment.api';
import { roleApi } from '../../domains/role/infrastructure/api/role.api';
import { orderApi } from '../../domains/order/infrastructure/api/order.api';
import { subscriptionApi } from '../../domains/subscription/infrastructure/api/subscription.api';
import { categoryApi } from '../../domains/category/infrastructure/api/category.api';
import { notificationApi } from '../../domains/notification/infrastructure/api/notification.api';
import { analyticsApi } from '../../domains/analytics/infrastructure/api/analytics.api';
import { configurationApi } from '../../domains/configuration/infrastructure/api/configuration.api';
import { reportApi } from '../../domains/report/infrastructure/api/report.api';
import { mentorApi } from '../../domains/mentor/infrastructure/api/mentor.api';
import { settingsApi } from '../../domains/settings/infrastructure/api/settings.api';
import { userProfileApi } from '../../domains/user/infrastructure/api/user.api';
import userProfileReducer from '../../domains/user/infrastructure/slices/userProfileSlice';

// New Slices
import analyticsReducer from './analyticsSlice';
import orderReducer from './orderSlice';
import categoryReducer from './categorySlice';
import paymentReducer from './paymentSlice';
import roleReducer from './roleSlice';
import notificationReducer from './notificationSlice';
import reportReducer from './reportSlice';
import configurationReducer from './configurationSlice';

// DDD Domain Slices
import authReducer from '../../domains/auth/infrastructure/slices/authSlice';

// Root Reducer
const rootReducer = combineReducers({
  authorization: authorizationReducer,
  user: userReducer,
  message: messageReducer,
  subscription: subscriptionReducer,
  feed: feedReducer,
  dynamic: dynamicReducer,
  roles: rolesReducer,
  language: languageReducer,

  // API Services - Legacy
  [userApi.reducerPath]: userApi.reducer,

  // DDD Domains - New structure
  [authApi.reducerPath]: authApi.reducer,
  [paymentApi.reducerPath]: paymentApi.reducer,
  [roleApi.reducerPath]: roleApi.reducer,
  [orderApi.reducerPath]: orderApi.reducer,
  [subscriptionApi.reducerPath]: subscriptionApi.reducer,
  [categoryApi.reducerPath]: categoryApi.reducer,
  [notificationApi.reducerPath]: notificationApi.reducer,
  [analyticsApi.reducerPath]: analyticsApi.reducer,
  [configurationApi.reducerPath]: configurationApi.reducer,
  [reportApi.reducerPath]: reportApi.reducer,
  [mentorApi.reducerPath]: mentorApi.reducer,
  [settingsApi.reducerPath]: settingsApi.reducer,
  [userProfileApi.reducerPath]: userProfileApi.reducer,

  // New Slices
  analytics: analyticsReducer,
  order: orderReducer,
  category: categoryReducer,
  payment: paymentReducer,
  role: roleReducer,
  notification: notificationReducer,
  report: reportReducer,
  configuration: configurationReducer,

  // DDD Domain Slices
  auth: authReducer,
  userProfile: userProfileReducer,
});

export default rootReducer;
